import {Button, Col, Divider, Modal, Row, Select, Space, Table} from "antd";
import {EyeOutlined,} from "@ant-design/icons";
import {useState} from "react";
import { Card } from "antd";
import { Form } from "antd";
import { Input } from "antd";
import {invest_title_img} from "../../../../AppImageConst";
const InvestMoneyRequestsComp = () => {

    const dataSource = [
        {
            key: '1',
            request_ID: 'R123',
            name: 'Dasun',
            portfolio_ID: 'P001',
        },
        {
            key: '2',
            request_ID: 'R124',
            name: 'Dasun',
            portfolio_ID: 'P001',
        },
    ];

    const columns = [
        {
            title: 'Request ID',
            dataIndex: 'request_ID',
            key: 'request_ID',
        },
        {
            title: 'Portfolio ID',
            dataIndex: 'portfolio_ID',
            key: 'portfolio_ID',
        },
        {
            title: 'Customer Name',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: () => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view '
                            onClick={showModal}
                            icon={<EyeOutlined/>}>View</Button>
                </Space>
            ),
        },
    ];
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
        setIsModalOpen(true);
    };

    // const handleOk = () => {
    //     setIsModalOpen(false);
    // };

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return(
        <>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'
                        style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
                        <div className='header_icon header-icon-center'>
                            <img style={{width:24,height:24}} src={invest_title_img} alt=""/>
                        </div>
                        Invest Money Requests
                    </h2>
                </Col>
            </Row>
            <Row gutter={[24, 12]}>
                <Col span={24}>
                    <Table size='small' dataSource={dataSource} columns={columns} scroll={{x: 'max-content'}}></Table>
                </Col>
            </Row>
            <Modal title="Invest Money Request" open={isModalOpen} footer={null} onCancel={handleCancel} width={800} centered  style={{ top: 20, paddingBottom:20 }}>
                <Row gutter={[24,12]} className={'form-item-mb-12'} style={{marginTop:18}}>
                    <Col span={24}>
                        <Card title="Request Details" size={'small'}>
                            <Form
                                className='form-input'
                                layout={"vertical"}
                            >
                                <Row gutter={[12,0]}>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label="Portfolio ID"
                                            name={'portfolio_id'}
                                            rules={
                                                [{required: true, message: 'Please select portfolio ID'}]}>
                                            <Select placeholder={"Select Portfolio ID"} size={'large'}

                                                    style={{width: '100%'}}
                                                    options={[
                                                        {value: 'jack', label: 'Jack'},
                                                        {value: 'lucy', label: 'Lucy'},
                                                        {value: 'Yiminghe', label: 'yiminghe'},
                                                    ]}

                                            >


                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label="Fund"
                                            name={'fund'}
                                            rules={
                                                [{required: true, message: 'Please select the fund'}]}>
                                            <Select placeholder={"Select the Fund"} size={'large'}

                                                    style={{width: '100%'}}
                                                    options={[
                                                        {value: 'jack', label: 'Jack'},
                                                        {value: 'lucy', label: 'Lucy'},
                                                        {value: 'Yiminghe', label: 'yiminghe'},
                                                    ]}

                                            >


                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label="Amount"
                                            name={'amount'}
                                            rules={
                                                [{required: true, message: 'Please enter the amount'}]}>
                                            <Input size={'large'}
                                                   placeholder={"Enter the Amount"}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label="Collection Account"
                                            name={'collection_account'}
                                            rules={
                                                [{required: true, message: 'Please select the collection account'}]}>
                                            <Select placeholder={"Select the Collection Account"} size={'large'}

                                                    style={{width: '100%'}}
                                                    options={[
                                                        {value: 'jack', label: 'Jack'},
                                                        {value: 'lucy', label: 'Lucy'},
                                                        {value: 'Yiminghe', label: 'yiminghe'},
                                                    ]}

                                            >


                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                        <Form.Item
                                            label="Transaction Reference Number"
                                            name={'tr_ref_no'}
                                            rules={
                                                [{
                                                    required: true,
                                                    message: 'Please enter the transaction reference number'
                                                }]}>
                                            <Input size={'large'}
                                                   placeholder={"Enter the Transaction Reference Number"}/>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{marginTop:8, marginBottom: 16,paddingRight: 28}}>
                                        <div className='utility_bill img-nic'>
                                            <div className='utulity_bill_icon_div'>
                                                <div className="img_div">
                                                    <img
                                                        src={''}
                                                        alt=""/>
                                                </div>
                                                <div className='name_div'>
                                                    <h5>Document</h5>
                                                    {/*<h6>Size: 5MB </h6>*/}
                                                </div>
                                            </div>
                                            <Button className='doc-view-btn'><EyeOutlined/></Button>
                                        </div>
                                    </Col>

                                </Row>
                            </Form>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginBottom: 12}}></Divider>
                    </Col>
                    <Col span={24} className={'request-auth-modal-btns-row'}>
                        <Space style={{float: 'right'}}>
                            <Button  size={'large'}
                                     onClick={handleCancel}
                                     style={{
                                         width: 120,
                                         marginRight: 8
                                     }}>Cancel</Button>
                            <Button  size={'large'} danger
                                    style={{
                                        width: 120,
                                    }}>Reject</Button>
                            <Button  size={'large'} type="success"
                                    style={{
                                        width: 120,
                                        background: "#008d86",
                                        color: "white",
                                    }}>Accept</Button>
                        </Space>
                    </Col>
                </Row>

            </Modal>
        </>
    )
}
export default InvestMoneyRequestsComp;